import { render } from "./SelectFree.vue?vue&type=template&id=63ca7f10"
import script from "./SelectFree.vue?vue&type=script&lang=js"
export * from "./SelectFree.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mfeys\\Desktop\\HAv2\\actions\\19480-florette\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__